/* MONO theme — stable interactions */
(function(){

  // Mobile header drawer
  document.querySelectorAll('[data-site-header]').forEach(function(header){
    var toggle = header.querySelector('[data-mobile-menu-toggle]');
    if(!toggle) return;

    function setOpen(open){
      header.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }

    toggle.addEventListener('click', function(){
      setOpen(!header.classList.contains('is-open'));
    });

    header.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){ setOpen(false); });
    });

    document.addEventListener('keydown', function(event){
      if(event.key === 'Escape') setOpen(false);
    });
  });

  // Working collection sort dropdown
  document.querySelectorAll('[data-sort-select]').forEach(function(select){
    select.addEventListener('change', function(){
      if(select.form) select.form.submit();
    });
  });

  // Variant picker on product page
  document.querySelectorAll('[data-variant-picker]').forEach(function(root){
    var data = root.querySelector('[data-variants-json]');
    if(!data) return;

    var variants = [];
    try {
      variants = JSON.parse(data.textContent || '[]');
    } catch(error) {
      return;
    }

    var idSelect = root.querySelector('select[name="id"]');
    var priceEl  = root.querySelector('[data-price]');
    var addBtn   = root.querySelector('[data-add]');

    function selectedOptions(){
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function(group){
        var on = group.querySelector('[aria-pressed="true"]');
        return on ? on.getAttribute('data-value') : null;
      });
    }

    function update(){
      var sel = selectedOptions();
      var match = variants.find(function(v){
        return v.options.every(function(o,i){ return o === sel[i]; });
      });

      if(match){
        if(idSelect) idSelect.value = String(match.id);
        if(priceEl && match.price) priceEl.textContent = match.price;
        if(addBtn){
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
        }
      } else if(addBtn){
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
    }

    root.querySelectorAll('[data-option-btn]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.closest('[data-option-index]');
        if(!group) return;
        group.querySelectorAll('[data-option-btn]').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
        btn.setAttribute('aria-pressed','true');
        update();
      });
    });

    update();
  });

  // Smooth product media thumbnail scrolling
  document.querySelectorAll('[data-product-media]').forEach(function(mediaRoot){
    mediaRoot.querySelectorAll('.pdp__thumb').forEach(function(thumb){
      thumb.addEventListener('click', function(event){
        var targetId = thumb.getAttribute('href');
        if(!targetId || targetId.charAt(0) !== '#') return;
        var target = mediaRoot.querySelector(targetId);
        if(!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    });
  });

})();
